var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(8.684 0.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 48,
    height: 48,
    transform: "translate(-8.684 -0.13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_18",
    "data-name": "Exclusion 18",
    d: "M7.861,44.033H7.819a8.006,8.006,0,0,1-5.11-2.1A7.956,7.956,0,0,1,.1,37.071a10.222,10.222,0,0,1-.08-1.309c0-1.4-.005-2.819-.011-4.193C0,28.492-.015,25.311.044,22.184a17.065,17.065,0,0,1,.811-4.958A14.942,14.942,0,0,1,6.381,9.658,17.432,17.432,0,0,1,10.856,7.35a17.777,17.777,0,0,1,5.856-1.039,16.041,16.041,0,0,1,4.433.63c.17.049.341.108.506.165l.238.081-.49.072-.017,0c-.675.1-1.312.189-1.954.345a13.562,13.562,0,0,0-5.349,2.588,14.858,14.858,0,0,0-3.739,4.615,19.208,19.208,0,0,0-2.1,7.107,35.878,35.878,0,0,0-.12,4.418c.009.618.018,1.257.013,1.885-.013,1.544,0,3.113.007,4.63v.013c0,.766.01,1.558.012,2.337q0,1.346,0,2.692c0,1.9.006,3.864.017,5.794a.383.383,0,0,1-.069.28A.33.33,0,0,1,7.861,44.033Zm8.6-4.682a19.834,19.834,0,0,1-5.868-.924.316.316,0,0,1-.273-.351c.007-3,.009-6.153.006-9.383,0-.046,0-.091.01-.148,0-.032.007-.067.01-.108l.171.137,0,0,.3.238a9.947,9.947,0,0,0,4.565,2.2,9.359,9.359,0,0,0,1.546.134,7.446,7.446,0,0,0,6.257-3.4A8.451,8.451,0,0,0,24.558,24.8a7.786,7.786,0,0,0,.123-3.074A8.107,8.107,0,0,0,23.6,18.8a9.285,9.285,0,0,0-2.233-2.5,7.226,7.226,0,0,0-4.549-1.616,9.537,9.537,0,0,0-3.05.544,12.054,12.054,0,0,0-1.772.8c0-.012-.01-.022-.014-.032s-.014-.029-.01-.035A13.17,13.17,0,0,1,18.679,9.9a10.754,10.754,0,0,1,3.831-.756,9.2,9.2,0,0,1,5.667,2.016,12.876,12.876,0,0,1,2.614,2.861,13.426,13.426,0,0,1,1.858,4.447,20.046,20.046,0,0,1,.433,5.009,16.037,16.037,0,0,1-1.1,5.435,16.473,16.473,0,0,1-6.939,8.153,16.1,16.1,0,0,1-5.189,1.962A18.17,18.17,0,0,1,16.459,39.351ZM4.171,8.343A4.121,4.121,0,0,1,1.239,7.13,4.188,4.188,0,1,1,4.2,8.343Z",
    transform: "translate(0 -0.13)",
    fill: "#3398cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3f1d701a0c4e506a087a15247c72123.svg";
export { ForwardRef as ReactComponent };